import { get } from 'es-toolkit/compat';
import { useEffect, useState } from 'react';
import isEqual from 'react-fast-compare';
import { useForm } from 'react-final-form';

type UseSpyOnFieldValueProps = {
  fieldPath: string;
  comparisonFunc?: (a: unknown, b: unknown) => boolean;
};

export const useSpyOnFieldValue = <T>({ fieldPath, comparisonFunc = isEqual }: UseSpyOnFieldValueProps): T | undefined => {
  const formApi = useForm();
  const [fieldValue, setFieldValue] = useState<T | undefined>(get(formApi.getState().values, fieldPath));

  useEffect(() => {
    const unsub = formApi.registerField(
      fieldPath,
      ({ value }) => {
        setFieldValue(value as T);
      },
      {
        value: true,
      },
      {
        isEqual: comparisonFunc,
      },
    );

    return () => {
      unsub();
    };
  }, [
    formApi,
    comparisonFunc,
    fieldPath,
  ]);

  return fieldValue;
};
